module.exports = __webpack_public_path__ + "static/the-opposable-mind-866d818986abf7a3798484dd6a6b0c73.jpg";